import React, { useRef, useState, useEffect } from 'react';
import { BASE_API } from '../../api/Globals';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'primereact/calendar';
import { helpHttp } from "../../helpers/helpHttp";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { addLocale } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Badge } from 'primereact/badge';
// import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from 'primereact/tooltip';
import { storage } from '../../helpers/storage';



import Menu from '../../components/sturtural/Menu';
import { Password } from 'primereact/password';

const initialForm = {
    DescripcionCicloEscolar: "",
    LinkVideoTutorial: "",
    Activo: true,
    EntregaKit: false,
    VigenciaCiclo: "",
    FechaInicioCiclo: null,
    FechaFinCiclo: null,
    LimitePrendas: 1,
    CantidadEvidencias: 1,
    HabilitarEntregaParcial: false,
    Visible: false,
    prendas: [""],
    evidencias: [""],
    proceso: null,
    otroProceso: "",
    Evento: false
}

const validationsFrom = (form) => {

    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
    let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    //let regexComments = /^.{1,255}$/;
    let regexDigitos = /^.{1,10}$/;
    let regexNumbers = /^([0-9])*$/;

    // Validación de ciclo escolar
    if (!form.DescripcionCicloEscolar.trim()) {
        errors.DescripcionCicloEscolar = "El Campo (Ciclo escolar) es requerido";
    }

    // Validación de límites numéricos
    if (!form.LimitePrendas || form.LimitePrendas === 0) {
        errors.LimitePrendas = "Cant. de prendas no permitido.";
    } else if (form.LimitePrendas < 1) {
        errors.LimitePrendas = "Debe haber al menos 1 prenda";
    }

    if (!form.CantidadEvidencias || form.CantidadEvidencias === 0) {
        errors.CantidadEvidencias = "Cantidad de evidencias no permitido.";
    } else if (form.CantidadEvidencias < 1) {
        errors.CantidadEvidencias = "Debe haber al menos 1 evidencia";
    } else if (form.CantidadEvidencias > 10) {
        errors.CantidadEvidencias = "Máximo 10 evidencias permitidas";
    }

    // Validación de fechas
    if (!form.FechaInicioCiclo) {
        errors.FechaInicioCiclo = "El Campo (Fecha inicio) es requerido";
    }

    if (!form.FechaFinCiclo) {
        errors.FechaFinCiclo = "El Campo (Fecha fin) es requerido";
    }

    // Validación de proceso
    if (!form.proceso) {
        errors.pProceso = "El Campo (Proceso) es requerido";
    }

    // Validación de prendas dinámicas
    if (form.prendas && form.prendas.length > 0) {
        form.prendas.forEach((prenda, index) => {
            if (!prenda) {
                errors[`prenda-${index}`] = `La Prenda ${index + 1} es requerida`;
            } else if (typeof prenda === 'object' && prenda.idprenda === 0) {
                // Validar que si es "Otros", el texto no esté vacío
                if (!prenda.Prenda || !prenda.Prenda.trim()) {
                    errors[`prenda-${index}`] = `Debe especificar la prenda ${index + 1}`;
                }
            }
        });
    }

    // Validación de evidencias dinámicas
    if (form.evidencias && form.evidencias.length > 0) {
        form.evidencias.forEach((evidencia, index) => {
            if (!evidencia) {
                errors[`evidencia-${index}`] = `La Evidencia ${index + 1} es requerida`;
            }
            // No validamos el estado 'activo' como error, ya que es opcional desactivar
        });
    }


    return errors;
}

const CreateCiclo = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [lstProcesos, setLstProcesos] = useState([]);
    const [lstTipoEvidencias, setLstTipoEvidencias] = useState([]);
    const [lstPrendas, setLstPrendas] = useState([]);
    const [showInput, setShowInput] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);
    const perfil = storage.get('perfilid');
    const usuario = storage.get('id');

    const toast = useRef(null);


    useEffect(() => {
        if (![1, 5, 9, 10, 11, 12, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        console.log(form)
    }, [form])

    useEffect(() => {
        getProcesos();
        getTipoEvidencias();
        getPrendas();
        getLinkVideotutorialUltimo();
    }, []);

    const getProcesos = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdConsultaProcesosListar",
                opcion: 0,
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                res.ITEMS.push({ idproceso: 0, proceso: "Otro" })
                setLstProcesos(res.ITEMS)
            }
        })
    }

       const getLinkVideotutorialUltimo = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdObtenerDatos",
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res?.SUCCESS) {
                const linkVideotutorialUltimo = res?.ITEMS?.[0]?.LinkVideoTutorial || "";
              
                setForm(prev => ({
                ...prev,
                LinkVideoTutorial: linkVideotutorialUltimo
            }));

        }
        })
    }

    const getTipoEvidencias = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdTipoDocumentoListar",
                opcion: 0,
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                // let items = res.ITEMS.unshift({})
                setLstTipoEvidencias(res.ITEMS)
            }
        })
    }

    const getPrendas = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdConsultaPrendaListar",
                opcion: 0,
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                res.ITEMS.push({ idprenda: 0, Prenda: "Otro" })
                setLstPrendas(res.ITEMS)
            }
        })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm(prevForm => {
            let newForm = { ...prevForm };

            if (name === "LimitePrendas") {
                const newLimit = parseInt(value) || 1;
                newForm.LimitePrendas = newLimit;

                // Ajustar array de prendas
                if (!newForm.prendas) newForm.prendas = [""];

                if (newLimit > newForm.prendas.length) {
                    // Agregar nuevas prendas vacías
                    for (let i = newForm.prendas.length; i < newLimit; i++) {
                        newForm.prendas.push("");
                    }
                } else {
                    // Remover prendas sobrantes
                    newForm.prendas = newForm.prendas.slice(0, newLimit);
                }
            }

            if (name === "CantidadEvidencias") {
                const newLimit = parseInt(value) || 1;
                newForm.CantidadEvidencias = newLimit;

                // Ajustar array de evidencias
                if (!newForm.evidencias) newForm.evidencias = [""];

                if (newLimit > newForm.evidencias.length) {
                    // Agregar nuevas evidencias vacías
                    for (let i = newForm.evidencias.length; i < newLimit; i++) {
                        newForm.evidencias.push("");
                    }
                } else {
                    // Remover evidencias sobrantes
                    newForm.evidencias = newForm.evidencias.slice(0, newLimit);
                }
            } else {
                newForm[name] = value;
            }

            return newForm;
        });
    };

    // Manejar cambio individual de prenda
    const handlePrendaChange = (index, selectedObject) => {
        setForm(prevForm => {
            const newPrendas = [...prevForm.prendas];

            // Si selecciona "Otros", inicializar con el objeto completo
            if (selectedObject && selectedObject.id === 0) {
                newPrendas[index] = { ...selectedObject, Prenda: "" }; // Objeto con texto vacío
            } else {
                newPrendas[index] = selectedObject; // Objeto normal o string vacío
            }

            return {
                ...prevForm,
                prendas: newPrendas
            };
        });
    };

    const handleOtraPrendaInputChange = (index, textValue) => {
        setForm(prevForm => {
            const newPrendas = [...prevForm.prendas];

            // Actualizar el texto de la prenda personalizada
            if (newPrendas[index] && typeof newPrendas[index] === 'object') {
                newPrendas[index] = {
                    ...newPrendas[index],
                    Prenda: textValue
                };
            }

            return {
                ...prevForm,
                prendas: newPrendas
            };
        });
    };

    const handleCloseOtraPrenda = (index) => {
        setForm(prevForm => {
            const newPrendas = [...prevForm.prendas];
            newPrendas[index] = ""; // Limpiar la selección

            return {
                ...prevForm,
                prendas: newPrendas
            };
        });
    };

    // Manejar cambio individual de evidencia
    const handleEvidenciaChange = (index, selectedObject) => {
        setForm(prevForm => {
            const newEvidencias = [...prevForm.evidencias];

            if (selectedObject) {
                // Si ya existe una evidencia en este índice, mantener el estado 'activo'
                const currentActivo = newEvidencias[index]?.obligatorio !== false; // true por defecto
                let objDescripcion = lstTipoEvidencias.find(x => x.IdTipoDocumento === selectedObject)

                newEvidencias[index] = {
                    IdTipoDocumento: selectedObject,
                    TipoDocumento: objDescripcion.TipoDocumento,
                    obligatorio: currentActivo
                };
            } else {
                // Si se limpia la selección, limpiar todo
                newEvidencias[index] = "";
            }

            return {
                ...prevForm,
                evidencias: newEvidencias
            };
        });
    };

    const handleEvidenciaSwitchChange = (index, checked) => {
        setForm(prevForm => {
            const newEvidencias = [...prevForm.evidencias];

            // Solo actualizar la propiedad 'activo', mantener el resto del objeto intacto
            if (newEvidencias[index] && typeof newEvidencias[index] === 'object') {
                newEvidencias[index] = {
                    ...newEvidencias[index],
                    obligatorio: checked
                };
            }

            return {
                ...prevForm,
                evidencias: newEvidencias
            };
        });
    };

    const handleDropdownChange = (e) => {
        const value = e.value;
        setForm({ ...form, proceso: value });
        if (value.idproceso === 0) {
            // Si elige "Otro", cambiamos a input
            setShowInput(true);
        } else {
            setShowInput(false);
        }
    };

    const handleInputChange = (e) => {
        setForm({ ...form, otroProceso: e.target.value });
    };

    const handleClose = () => {
        // Al cerrar, regresamos al dropdown
        setShowInput(false);
        setForm({ ...form, proceso: null, otroProceso: "" });
    };

    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFrom(form));
    };

    const handleResponse = () => {
        setResponse(false);
        showToast('error', 'Error de captcha', 'Favor de aceptar el captcha');
    }

    const showToast = (severity, summary, detail) => {
        toast.current.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: 5000
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setErrors(validationsFrom(form));

        if (Object.keys(validationsFrom(form)).length === 0) {
            if (form.FechaInicioCiclo < form.FechaFinCiclo) {
                console.log('form.LinkVideoTutorial', form.LinkVideoTutorial)
                const arrUser = {
                    Opcion: "A",
                    IdCicloEscolar: 0,
                    DescripcionCicloEscolar: form.DescripcionCicloEscolar,
                    LinkVideoTutorial: form.LinkVideoTutorial,
                    LinkSistema: "",
                    EntregaKit: form.EntregaKit,
                    VigenciaCiclo: form.VigenciaCiclo,
                    Activo: form.Activo,
                    LimitePrendas: form.LimitePrendas,
                    HabilitarEntregaParcial: form.HabilitarEntregaParcial,
                    Visible: form.Visible,
                    IdPerfil: perfil,
                    IdUsuario: usuario,
                    TextoCiclo: "",
                    Evento: form.Evento,
                    FechaInicioCiclo: form.FechaInicioCiclo.toISOString().split('T')[0],
                    FechaFinCiclo: form.FechaFinCiclo.toISOString().split('T')[0],
                    cantidadevidencias: form.CantidadEvidencias,
                    proceso: showInput ? JSON.stringify({ idproceso: 0, proceso: form.otroProceso }) : JSON.stringify(form.proceso),
                    prendas: JSON.stringify(form.prendas),
                    documentos: JSON.stringify(form.evidencias)


                };

                setLoading(true);


                helpHttp().post(`${BASE_API}Usuarios/SpdCrudCicloEscolar`, {
                    body: arrUser,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    },
                }).then((res) => {

                    if (res.SUCCESS) {
                        showToast('success', 'Mensaje:', 'Ciclo registrado correctamente');
                        return navigate('/configuracion/ciclo');
                    } else {
                        setMessage(res.MESSAGE);
                        console.warn(res.MESSAGE)
                        setAviso(true);
                    }
                });
                setLoading(false);
            } else {
                showToast('warn', 'Mensaje:', 'Formato de fecha inválido.');
                return;
            }
        } else {
            showToast('warn', 'Mensaje:', 'Favor de llenar los campos requeridos.');
            return;
        }
    };

    const handlerRedirect = () => {
        setMessage(null);
        setAviso(false)
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button" />;

    return (
        <>
            <div className="grid">
                <Toast ref={toast} />

                <Menu link='filtro' />

                <form onSubmit={handleSubmit} className="col-12" autoComplete="none">
                    <div className="card">
                        <Tooltip target=".custom-target"/>

                        <div className="col-12 lg:flex md:flex sm:flex">
                            <div className='col-12 lg:col-6 md:col-6 sm:col-6'>
                                <h4 style={{ fontWeight: '700' }}>Nuevo ciclo</h4>
                            </div>

                            <div className='col-12  p-0 lg:col-6 md:col-6 sm:col-6 text-left xl:text-right lg:text-right md:text-right sm:text-right'>
                                <label style={{ color: 'red' }}>* Campos obligatorios</label>
                            </div>
                        </div>
                        <div className="p-fluid formgrid grid">

                            <div className='col-12 mt-5'>
                                <h6><Badge value="1" className='mr-2' size="large" style={{ fontSize: '12px'}}></Badge>LLENA LOS DATOS GENERALES</h6>
                                <hr style={{ border: '5px' }} />
                            </div>

                            <div className="field col-12 lg:col-2 md:col-6">
                                <label htmlFor="usuario"><label style={{ color: 'red' }}>*</label> Ciclo escolar</label>
                                <InputText autoComplete="none" id="DescripcionCicloEscolar" name="DescripcionCicloEscolar" type="text" value={form.usuario} onChange={handleChange} className={errors.DescripcionCicloEscolar && 'p-invalid'} autoFocus />
                                {errors.DescripcionCicloEscolar && <small className="p-error">{errors.DescripcionCicloEscolar}</small>}
                            </div>

                            <div className="field col-12 lg:col-3 md:col-6">
                                <label htmlFor="proceso"><label style={{ color: 'red' }}>*</label> Proceso</label>
                                {!showInput ? (
                                    <Dropdown id="proceso" name="proceso" value={form.proceso} optionLabel="proceso" options={lstProcesos} onChange={handleDropdownChange} placeholder="Selecciona" className="w-full" style={{ textTransform: 'uppercase' }} panelStyle={{ textTransform: 'uppercase' }} />
                                ) : (
                                    <span className="p-input-icon-right w-full">
                                        <i id='iconInputOtro' className="pi pi-times cursor-pointer text-gray-700 hover:text-orange-500" onClick={handleClose} />
                                        <InputText id="otroProceso" value={form.otroProceso} onChange={handleInputChange} placeholder="Especifica otro proceso" className="w-full" />
                                    </span>
                                )}
                                {errors.otroProceso && <small className="p-error">{errors.otroProceso}</small>}
                            </div>

                            <div className='field col-12 lg:col-2 md:col-6'>
                                <label htmlFor="FechaInicioCiclo"><label style={{ color: 'red' }}>*</label> Fecha inicio</label>
                                <i className='pi pi-info-circle ml-2 custom-target' data-pr-tooltip='Fecha para vigencia del vale'></i>
                                <Calendar id='FechaInicioCiclo' name='FechaInicioCiclo' className={errors.FechaInicioCiclo && 'p-invalid'} locale='es' dateFormat='dd/mm/yy' showIcon showButtonBar value={form.FechaInicioCiclo} onChange={handleChange}></Calendar>
                                {errors.FechaInicioCiclo && <small className="p-error">{errors.FechaInicioCiclo}</small>}
                            </div>
                            <div className='field col-12 lg:col-2 md:col-6'>
                                <label htmlFor="FechaFinCiclo"><label style={{ color: 'red' }}>*</label> Fecha fin</label>
                                <i className='pi pi-info-circle ml-2 custom-target' data-pr-tooltip='Fecha para vigencia del vale'></i>
                                <Calendar id='FechaFinCiclo' name='FechaFinCiclo' className={errors.FechaFinCiclo && 'p-invalid'} locale='es' dateFormat='dd/mm/yy' showIcon showButtonBar value={form.FechaFinCiclo} onChange={handleChange}></Calendar>
                                {errors.FechaFinCiclo && <small className="p-error">{errors.FechaFinCiclo}</small>}
                            </div>


                            <div className="field col-12 lg:col-3">
                                <label htmlFor="usuario">Link de videotutorial (carga de evidencias)</label>
                                <InputText autoComplete="none" id="LinkVideoTutorial" name="LinkVideoTutorial" type="text" value={form.LinkVideoTutorial} onChange={handleChange} className={errors.LinkVideoTutorial && 'p-invalid'} />
                                {errors.LinkVideoTutorial && <small className="p-error">{errors.LinkVideoTutorial}</small>}
                            </div>


                            
                            <div className="field mt-3 col-12 lg:col-5 md:col-6 sm:col-6 block xl:flex lg:flex pl-0">
                                <div className="col-12 xl:col-5 lg:col-5 flex mb-1">
                                    <InputSwitch id='estilodeSwitc' name='HabilitarEntregaParcial' className='mr-2' checked={form.HabilitarEntregaParcial} onChange={handleChange} />
                                    <label htmlFor="HabilitarEntregaParcial">Entrega parcial</label>
                                </div>
                                <div className="col-12 xl:col-6 lg:col-6 flex">
                                    <InputSwitch id='estilodeSwitc' name='EntregaKit' className='mr-2' checked={form.EntregaKit} onChange={handleChange} />
                                    <label htmlFor="EntregaKit">Entrega kit</label>
                                </div>
                            </div>

                            <div className="field mt-3 col-12 lg:col-4 md:col-6 sm:col-6 block xl:flex lg:flex pl-0">
                                <div className="col-12 xl:col-6 lg:col-6 flex mb-1">
                                    <InputSwitch id='estilodeSwitc' name='Evento' className='mr-2' checked={form.Evento} onChange={handleChange} />
                                    <label htmlFor="Evento">Habrá sede</label>
                                </div>
                                <div className="col-12 xl:col-6 lg:col-6 flex">
                                    <InputSwitch id='estilodeSwitc' name='Visible' className='mr-2' checked={form.Visible} onChange={handleChange} />
                                    <label htmlFor="Visible">Visible director</label>
                                </div>
                            </div>

                            <div className='col-12 mt-8'>
                                <h6><Badge value="2" className='mr-2' size="large" style={{ fontSize: '12px' }}></Badge>INDICA LAS PRENDAS</h6>
                                <hr style={{ border: '5px' }} />
                            </div>

                            <div className="field col-12 lg:col-3 md:col-6">
                                <label htmlFor="LimitePrendas"><label style={{ color: 'red' }}>*</label> Prendas en catálogo</label>
                                <InputNumber id='LimitePrendas' name='LimitePrendas' value={form.LimitePrendas} onValueChange={handleChange} className={errors.LimitePrendas && 'p-invalid'} mode="decimal" showButtons min={1} />
                                {errors.LimitePrendas && <small className="p-error">{errors.LimitePrendas}</small>}
                            </div>
                            <>
                                {Array.from({ length: form.LimitePrendas }, (_, i) => (
                                    <div key={`prenda-${i}`} className="field col-12 lg:col-3 md:col-6">
                                        <label htmlFor={`prenda-${i}`}>
                                            <label style={{ color: 'red' }}>*</label> Prenda {i + 1}
                                        </label>

                                        {!form.prendas[i] || (form.prendas[i] && form.prendas[i].idprenda !== 0) ? (
                                            // Dropdown normal
                                            <Dropdown
                                                id={`prenda-${i}`}
                                                value={form.prendas[i] || ""}
                                                options={lstPrendas}
                                                optionLabel="Prenda"
                                                placeholder="Selecciona"
                                                emptyMessage='Opciones no disponibles'
                                                className={errors[`prenda-${i}`] && 'p-invalid'}
                                                onChange={(e) => {
                                                    const selected = e.value
                                                    if (selected.idprenda === 0) {
                                                        handlePrendaChange(i, { idprenda: 0, Prenda: "" })
                                                    } else {
                                                        handlePrendaChange(i, selected)
                                                        
                                                    }
                                                }}
                                                style={{ textTransform: 'uppercase' }}
                                                panelStyle={{ textTransform: 'uppercase' }}
                                            />
                                        ) : (
                                            <span className="p-input-icon-right w-full">
                                                <i id='iconInputOtro' className="pi pi-times cursor-pointer text-gray-700 hover:text-orange-500" onClick={() => handleCloseOtraPrenda(i)} />
                                                <InputText
                                                    id={`prenda-${i}-input`}
                                                    value={form.prendas[i]?.Prenda || ""}
                                                    placeholder="Especifica otra prenda"
                                                    className={"w-full"}
                                                    onChange={(e) => handleOtraPrendaInputChange(i, e.target.value)}
                                                />
                                            </span>
                                        )}

                                        {errors[`prenda-${i}`] && <small className="p-error">{errors[`prenda-${i}`]}</small>}
                                    </div>
                                ))}
                            </>

                            <div className='col-12 mt-8'>
                                <h6><Badge value="3" className='mr-2' size="large" style={{ fontSize: '12px' }}></Badge>CONFIGURA LAS EVIDENCIAS</h6>
                                <hr style={{ border: '5px' }} />
                            </div>

                            <div className="field col-12 lg:col-3 md:col-6">
                                <label htmlFor="CantidadEvidencias"><label style={{ color: 'red' }}>*</label> Cantidad evidencias</label>
                                <InputNumber id='CantidadEvidencias' name='CantidadEvidencias' value={form.CantidadEvidencias} onValueChange={handleChange} className={errors.CantidadEvidencias && 'p-invalid'} mode="decimal" showButtons min={1} max={4} />
                                {errors.CantidadEvidencias && <small className="p-error">{errors.CantidadEvidencias}</small>}
                            </div>

                            <>
                                {Array.from({ length: form.CantidadEvidencias || 0 }, (_, i) => (
                                    <div key={`evidencia-${i}`} className="field mb-6 col-12 lg:col-3 md:col-6 sm:col-12">
                                        <div className="flex flex-column">
                                            <label htmlFor={`evidencia-${i}`}>
                                                <label style={{ color: 'red' }}>*</label> Evidencia {i + 1}
                                            </label>

                                            {/* Dropdown - mostrar siempre la evidencia seleccionada aunque esté inactiva */}
                                            <Dropdown
                                                id={`evidencia-${i}`}
                                                value={form.evidencias[i].IdTipoDocumento || ""}
                                                options={lstTipoEvidencias}
                                                optionLabel="TipoDocumento"
                                                optionValue="IdTipoDocumento"
                                                placeholder="Selecciona evidencia"
                                                emptyMessage="Opciones no disponibles"
                                                className={errors[`evidencia-${i}`] && 'p-invalid'}
                                                onChange={(e) => handleEvidenciaChange(i, e.value)}
                                                style={{ width: '100%', marginBottom: '0.5rem', textTransform: 'uppercase' }}
                                                panelStyle={{ textTransform: 'uppercase' }}
                                            />

                                            {/* InputSwitch - solo controla el estado activo/inactivo */}
                                            <div className="flex align-items-center justify-content-start mt-0 ml-2">
                                                <InputSwitch
                                                    id={`switch-evidencia-${i}`}
                                                    className='estilodeSwitc'
                                                    checked={form.evidencias[i]?.obligatorio === true}
                                                    onChange={(e) => handleEvidenciaSwitchChange(i, e.value)}
                                                    disabled={!form.evidencias[i]} // Solo deshabilitar si no hay evidencia seleccionada
                                                />
                                                <label htmlFor={`switch-evidencia-${i}`} className="ml-2" style={{color:'#5e5e5eff'}}>Obligatorio</label>                                
                                            </div>

                                            {errors[`evidencia-${i}`] && <small className="p-error">{errors[`evidencia-${i}`]}</small>}
                                        </div>
                                    </div>
                                ))}
                            </>

                        </div>
                        <div className="p-dialog-footer text-right" style={{ marginTop: '15px', paddingTop: '15px' }}>
                            <Button type='button' disabled={loading} label="Cancelar" icon='pi pi-times' className="p-button-outlined mr-2 mb-2" onClick={() => navigate('/configuracion/ciclo')} />
                            <Button disabled={loading} loading={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} type='submit' label="Guardar" className="p-component mr-2 mb-2" />
                        </div>
                    </div>
                </form>
            </div>

            <Dialog header="AVISO" closable={false} draggable={false} visible={aviso} onHide={() => handlerRedirect} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default CreateCiclo;